// The AgriDrain reading is an unsigned 12-bit ADC value. This value is first converted to volts and then to distance in meters (m) using an empirically derived linear equation. Convert the 12-bit value ($rdg in code below) to distance ($dis in code below) using the following algorithm:

/*
$dis = 0.0;
if ( $rdg == 0xFFF )
{
  $dis = null; // display reading as “invalid”
}
else
{
  $slope = 31.8030308285392000;
  $intercept = 7.1934178791823500;

  $volt = ((float)$rdg)/327.6;
  $dis = (($slope * $volt) + $intercept) * 0.0254;

  if ($dis < 0.0) {
    $dis = 0.0;
  }
}
*/

export function agridrain(
  reading: number,
  scale: number,
  offset: number,
  frequency: number
): number {
  const slope = 31.8030308285392
  const intercept = 7.19341787918235
  const voltage = reading / 327.6
  const distance = (slope * voltage + intercept) * 0.0254

  return distance < 0.0 ? 0.0 : distance
}
